import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageJa() {
    return (
//         <div className="privacy-policy-container">
// <h1>プライバシーポリシー</h1>
// <p>最終更新日：2024年1月18日</p>

// <p>このプライバシー通知は、Yuzult（「私たち」、「私たち」、または「私たちの」）がサービス（「サービス」）を使用する際に情報を収集し、保存し、使用し、または共有する方法とその理由について説明しています。 以下は、当社のモバイルアプリケーション（Tasbih Dhikr）をダウンロードして使用したり、このプライバシー通知にリンクする他のアプリケーションを含む、当社のサービスを使用する際に適用されます。</p>
// <ul>
//     <li>当社のモバイルアプリケーション（Tasbih Dhikr）をダウンロードして使用する場合、またはこのプライバシー通知にリンクする当社の他のアプリケーションをダウンロードして使用する場合</li>
//     <li>販売、マーケティング、またはイベントを含む、他の関連する方法で当社と関わる場合</li>
// </ul>
// <p>質問や懸念事項はありますか？ このプライバシー通知を読むことで、プライバシーの権利と選択肢を理解できます。 当社のポリシーと実践に同意しない場合は、当社のサービスを使用しないでください。</p>

// <h2>主要なポイントの要約</h2>
// <p>この要約にはプライバシー通知からの主要なポイントが含まれていますが、それぞれのトピックの詳細については、各主要なポイントに続くリンクをクリックするか、以下の目次を使用して必要なセクションを探すことができます。</p>

// <h2>目次</h2>
// <ol>
//     <li>収集する情報は何ですか？</li>
//     <li>情報の処理方法はどのようになりますか？</li>
//     <li>個人情報を処理するための法的根拠は何ですか？</li>
//     <li>いつ、誰と情報を共有しますか？</li>
//     <li>情報はどのくらいの期間保管しますか？</li>
//     <li>情報の安全な保管方法は何ですか？</li>
//     <li>プライバシー権利は何ですか？</li>
//     <li>Do-Not-Track機能のコントロール</li>
//     <li>米国の居住者には特定のプライバシー権利がありますか？</li>
//     <li>この通知を更新しますか？</li>
//     <li>この通知に関してどのように連絡すればよいですか？</li>
//     <li>収集したデータをどのように確認、更新、または削除できますか？</li>
// </ol>

// <h3>1. 収集する情報は何ですか？</h3>
// <h4>私たちに開示する個人情報</h4>
// <p>要するに：私たちは、あなたが提供する個人情報を収集します。</p>
// <p>私たちは、私たちや私たちの製品やサービスに関する情報を取得しようとする興味を表明する際、またはサービスの活動に参加し、または私たちに連絡する際に、あなたが自発的に提供する個人情報を収集します。</p>
// <p>センシティブな情報。私たちはセンシティブな情報を処理しません。</p>
// <p>提供するすべての個人情報は真実、完全、正確でなければならず、そのような個人情報に変更がある場合は通知する必要があります。</p>

// <h3>2. どのようにして情報を処理しますか？</h3>
// <p>要するに：私たちは情報を提供し、改善し、管理し、お客様と連絡を取り、セキュリティおよび詐欺防止、法令の遵守のために処理します。 お客様の同意に基づいて情報を他の目的で処理することもあります。</p>
// <p>お客様の個人情報は、お客様が当社のサービスとのやり取り方法に応じて、さまざまな理由で処理されます。</p>
// <ul>
//     <li>個人の生命を保存または保護するため。 お客様の情報を処理する場合、危害を防ぐためなど、個人の生命を保存または保護する必要がある場合があります。</li>
// </ul>

// <h3>3. どの法的根拠を信頼して情報を処理しますか？</h3>
// <p>要するに：私たちは、適用法に基づき、個人情報の処理が必要であり、有効な法的根拠（すなわち、法的根拠）がある場合にのみ、個人情報を処理します。 これには、あなたの同意、法令の遵守、契約上の義務を履行するためのサービスの提供、あなたの権利の保護、または正当なビジネス利益を達成するための場合が含まれます。</p>
// <p>EUまたはUKに居住している場合、このセクションが適用されます。</p>
// <p>一般データ保護規則（GDPR）およびUK GDPRでは、個人情報を処理するために頼る有効な法的根拠を説明するよう求められています。 したがって、私たちは個人情報を処理するために以下の法的根拠に頼ることがあります：</p>
// <ul>
//     <li>同意。 お客様が特定の目的で個人情報を使用する許可（同意）を与えた場合、私たちはお客様の情報を処理することができます。 お客様はいつでも同意を撤回できます。</li>
//     <li>法的義務。 私たちは、法執行機関や規制機関と協力し、法的権利を行使または保護し、私たちが関与する訴訟の証拠としてお客様の情報を開示するなど、法的義務を遵守する必要があると信じる場合、お客様の情報を処理することがあります。</li>
//     <li>生命の保存に必要な場合。 お客様または第三者の生命の保存に必要であると考える場合、例えば、いかなる人の安全に対する潜在的な脅威を含む状況。</li>
// </ul>
// <p>カナダに居住している場合、このセクションが適用されます。</p>

//                        {/* Continuation de la section 3 */}
//                        <p>特定の目的（すなわち、明示的な同意）に個人情報を使用するための特別な許可を私たちに与えた場合、または許可が推定できる場合（すなわち、暗黙の同意）に、情報を処理することがあります。 いつでも同意を撤回できます。</p>
// <p>一部の例外的なケースでは、適用法に基づいて許可なしに情報を処理することが法的に許可される場合があります。 たとえば次の場合が挙げられます：</p>
// <ul>
//     <li>収集が個人の利益に明白であり、適時に同意を得ることができない場合</li>
//     <li>調査および詐欺の検出および予防のため</li>
//     <li>一定の条件が満たされた場合のビジネス取引</li>
//     <li>証人陳述書に含まれており、情報の収集が保険請求を評価、処理、または解決するために必要な場合</li>
//     <li>傷病者、病者、または死亡者を特定し、身内と連絡を取るため</li>
//     <li>個人が金融的虐待の被害者であると合理的な根拠がある場合</li>
//     <li>同意なしに収集と使用が情報の利用可能性または正確性を損なう可能性があり、合意に関連する目的のために収集が合理的な場合、合意が必要な場合</li>
//     <li>記録の作成に関連する合意に準拠して、召喚状、令状、裁判所命令、または記録の提出に関する裁判所の規則を遵守するため</li>
//     <li>個人が雇用、ビジネス、または専門活動の過程で作成した情報であり、情報が作成された目的に一致する場合</li>
//     <li>情報の収集がジャーナリズム、芸術、または文学の目的のために唯一の場合</li>
//     <li>情報が一般に利用可能であり、規制によって指定されている場合</li>
// </ul>


//                        {/* Section 4 */}
//                        <h3>4. いつ、誰と情報を共有しますか？</h3>
// <p>要約すると: このセクションで説明されている特定の状況や、以下の第三者と情報を共有することがあります。</p>
// <p>以下の状況で個人情報を共有する必要があるかもしれません：</p>
// <ul>
//     <li>ビジネスの移転。当社のビジネスの一部または全部を別の会社に対しての合併、会社の資産の売却、資金調達、または取得の交渉中、またはそれに関連して情報を共有または転送することがあります。</li>
// </ul>

// <h3>5. 情報をどのくらい保持しますか？</h3>
// <p>要約すると: 法律によって要求されない限り、このプライバシー通知で述べられている目的を達成するために必要な期間だけ情報を保持します。</p>
// <p>個人情報は、このプライバシー通知で設定された目的のために必要な限りのみ保持します。法律（税金、会計、その他の法的要件など）によって長期の保持期間が必要または許可されている場合を除きます。</p>
// <p>当社が個人情報を処理するための正当なビジネスニーズがない場合、その情報を削除または匿名化し、削除が可能になるまでの間、個人情報を安全に保管し、その後の処理から分離します。</p>

// <h3>6. 情報をどのように安全に保つのですか？</h3>
// <p>要約すると: 私たちは組織的および技術的なセキュリティ対策のシステムを通じて個人情報を保護しようとしています。</p>
// <p>私たちは個人情報を処理する際のセキュリティを保護するために適切で合理的な技術的および組織的なセキュリティ対策を実施しています。ただし、セキュリティを確保し、情報を100%安全に保護できると保証することはできません。したがって、ハッカーやサイバー犯罪者、または他の不正な第三者がセキュリティを破り、情報を不正に収集、アクセス、盗難、または変更する可能性を約束または保証することはできません。私たちは個人情報を保護するために最善を尽くしますが、個人情報の送受信は自己責任で行う必要があります。安全な環境でのみサービスにアクセスすべきです。</p>

// <h3>7. あなたのプライバシー権利は何ですか？</h3>
// <p>要約すると: ヨーロッパ経済領域（EEA）、イギリス（UK）、スイス、およびカナダなど、一部の地域では、あなたにより多くのアクセス権と個人情報のコントロールを許可する権利があります。いつでもアカウントを確認、変更、または解約できます。</p>
// <p>一部の地域（EEA、UK、スイス、およびカナダなど）では、該当するデータ保護法に従って特定の権利を有することがあります。これには、次の権利が含まれる場合があります：(i) 個人情報へのアクセスとコピーの取得を要求する権利、(ii) 訂正または消去を要求する権利；(iii) 個人情報の処理を制限する権利；(iv) 該当する場合、データの携帯性；および(v) 自動決定に対する権利を受けない権利。特定の状況では、個人情報の処理に対する異議を申し立てる権利もある場合があります。詳細については、「この通知に関してお問い合わせいただく方法」のセクションで提供された連絡先詳細を使用して、そのような要求を行うことができます。</p>
// <p>同意の撤回：個人情報の処理に関してあなたの同意に依存している場合（該当する法律に応じて明示的または暗黙の同意が含まれる場合）、いつでも同意を撤回する権利があります。同意を撤回するには、「この通知に関してお問い合わせいただく方法」のセクションで提供された連絡先詳細を使用していつでも同意を撤回できます。ただし、これによって撤回前の処理の適法性に影響を与えないことや、該当する法律が許可する場合には同意以外の適法な処理の基盤に依存して行われる場合には影響を与えないことに注意してください。</p>

// <h3>8. ダイ・ノット・トラック（DNT）機能の制御</h3>
// <p>ほとんどのウェブブラウザと一部のモバイルオペレーティングシステムおよびモバイルアプリケーションには、オンラインのブラウジング活動に関するデータを監視および収集しないようにするプライバシー設定または機能をアクティブ化できる「ダイ・ノット・トラック（DNT）」機能または設定が含まれています。現時点では、DNT信号を認識および実装するための一貫した技術基準はまだ確定していないため、私たちは現在、オンラインでの追跡を行わないことを自動的に通知するメカニズムを含むDNTブラウザ信号または他のメカニズムには対応していません。将来的に追跡に関するオンライン標準が採用される場合、その実践についてはこのプライバシー通知の改訂版でお知らせする予定です。</p>

//             {/* Section 9 */}
//             <h3>9. 米国居住者は特定のプライバシー権利を有していますか？</h3>
// <p>要約すると: 米国の居住者の場合、個人情報へのアクセスに関する特定の権利が付与されます。</p>
// <p>私たちはどのような種類の個人情報を収集していますか？</p>
// <p>過去12ヶ月間に、次のカテゴリの個人情報を収集しています：</p>
// <table>
//     <tr>
//         <th>カテゴリ</th>
//         <th>例</th>
//         <th>収集済み</th>
//     </tr>
//     <tr>
//         <td>A. 識別情報</td>
//         <td>連絡先情報、実名、別名、郵便物の送付先住所、電話番号または携帯電話の連絡先番号、固有の個人識別子、オンライン識別子、インターネットプロトコル（IP）アドレス、電子メールアドレス、アカウント名など</td>
//         <td>いいえ</td>
//     </tr>
//     <tr>
//         <td>B. 州法または連邦法に基づく保護分類の特性</td>
//         <td>性別および生年月日</td>
//         <td>いいえ</td>
//     </tr>
// </table>

//                 {/* ... Autres catégories ... */}
//                 <p>また、以下の状況で、対話を通じて個人情報を収集することがあります：</p>
// <ul>
//     <li>お客様サポートチャネルを通じてヘルプを受ける</li>
//     <li>顧客調査やコンテストに参加する</li>
//     <li>サービスの提供を支援し、お客様のお問い合わせに対応する</li>
// </ul>
// <p>どのようにして個人情報を使用し、共有しますか？</p>
// <p>個人情報の使用方法については、「個人情報の処理方法はどのようになっていますか？」のセクションで詳細を学びます。</p>
// <p>あなたの情報は他の誰かと共有されますか？</p>
// <p>サービスプロバイダーとの間に締結された書面契約に基づいて、個人情報を開示する場合があります。個人情報の開示について詳しくは、「個人情報をいつ、誰と共有しますか？」のセクションでご確認いただけます。</p>
// <p>私たちは過去12ヶ月間、ビジネスまたは商業目的で第三者に個人情報を開示、販売、または共有していません。将来的にもウェブサイトの訪問者、ユーザー、および他の消費者の個人情報を販売または共有しません。</p>


//             {/* Section 10 */}
//             <h3>10. この通知は更新されますか？</h3>
// <p>要約：はい、関連する法律に準拠するために必要な場合に、この通知を更新します。</p>
// <p>このプライバシー通知を定期的に更新することがあります。更新されたバージョンは更新された「改訂日」で示され、更新されたバージョンはアクセス可能になった時点から有効になります。このプライバシー通知に重大な変更が加えられた場合、その変更の通知を目立つ形で掲示するか、直接通知を送信することがあります。お客様には、私たちがどのように情報を保護しているかを把握するために、このプライバシー通知を頻繁に確認することをお勧めします。</p>

// <h3>11. この通知についてお問い合わせいただく方法は？</h3>
// <p>この通知に関するご質問やコメントがある場合、以下の住所までご連絡いただけます：Yuzult</p>

// <h3>12. 私たちが収集するデータの確認、更新、または削除はどのように行えますか？</h3>
// <p>お住まいの国の適用法に基づき、私たちが収集した個人情報にアクセスをリクエストし、その情報を変更または削除する権利があるかもしれません。個人情報の確認、更新、または削除をリクエストするには、データ主体アクセスリクエストを記入し、提出してください。</p>

       
//         </div>
<div className="privacy-policy-container">
<h1>タスビーフ・ディクル・ライト プライバシーポリシー</h1>
     <p>最終更新日: 2024年7月30日</p>

     <h2>はじめに</h2>
     <p>タスビーフ・ディクル・ライトアプリへようこそ。このプライバシーポリシーは、アプリを使用する際にお客様のデータをどのように扱うかについてご説明することを目的としています。このアプリでのデータ収集はGoogleの広告サービスであるAdMobによってのみ行われ、私たちは積極的に個人データを収集しません。</p>

     <h2>1. お客様の個人データの収集と利用</h2>
     <h3>a. 収集されるデータの種類</h3>
     <h4>i. AdMobを通じたデータ利用</h4>
     <p>当アプリは広告を表示するためにAdMobを使用しています。AdMobはお客様のIPアドレス、デバイスID、アプリ利用情報などのデータを収集することがあります。これらの情報は広告体験を提供し、改善するために使用されます。</p>

     <h3>b. データの利用目的</h3>
     <p>AdMobによって収集されるデータは以下の目的で利用されます：</p>
     <ul>
       <li>アプリ内での広告の提供およびパーソナライズ。</li>
       <li>表示される広告の効果分析。</li>
     </ul>

     <h3>c. ユーザーのコントロール</h3>
     <p>お客様は、デバイスの設定を通じて、パーソナライズされた広告に対するデータの使用を制御することができます。</p>

     <h2>2. データの転送</h2>
     <p>お客様の情報は、お客様の居住国、州、地域のデータ保護法と異なる場合があるコンピュータに転送され、保持される可能性があります。</p>

     <h2>3. お客様の個人データの開示</h2>
     <p>AdMobによって収集されたデータは、Googleのプライバシーポリシーおよび法的要件に従って共有されることがあります。</p>

     <h2>4. お客様の個人データの安全性</h2>
     <p>お客様のデータの安全性は私たちにとって重要です。しかし、インターネット上の送信方法や電子的な保存方法は100%安全ではありません。</p>

     <h2>5. 他サイトへのリンク</h2>
     <p>当サービスには他のサイトへのリンクが含まれている場合があります。第三者のリンクをクリックすると、その第三者のサイトにリダイレクトされます。</p>

     <h2>6. このプライバシーポリシーの変更</h2>
     <p>私たちは時々プライバシーポリシーを更新する可能性があります。変更がある場合は、このページに新しいプライバシーポリシーを掲載することでお知らせします。</p>

     <h2>7. お問い合わせ</h2>
     <p>このプライバシーポリシーに関してご質問がある場合は、お問い合わせください。</p>

     <h2>役立つリンク</h2>
     <p><a href="https://policies.google.com/privacy">Googleのプライバシーポリシー</a></p>
   </div>
    );
}

export default PrivacyPolicyPageJa;
